var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Index"},[_c('headNav',{attrs:{"activeNav":'Inicio'}}),_c('Inicio'),_c('footPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }